import { FeatureFlag, PlansColumns } from '../models';
import { RawAxiosHeaders } from '../interceptors';

export class UtilService {
  public static dateToUtc = (date: Date) => {
    const dateUtc = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds(),
    );
    return Math.floor(dateUtc.getTime() / 1000);
  };

  public static secondsToTime(seconds: number) {
    const m = Math.floor(seconds % 3600 / 60).toString().padStart(2, '0');
    const s = Math.floor(seconds % 60).toString().padStart(2, '0');
    return { m, s };
  }

  public static getEnableFeatureHeader = (...featureFlag: FeatureFlag[]) => ({
    'x-enable-feature': featureFlag.join(','),
  });

  public static getDisableFeatureHeader = (...featureFlag: FeatureFlag[]) => ({
    'x-disable-feature': featureFlag.join(','),
  });

  public static addFeatureHeader = (
    existingHeaders: RawAxiosHeaders | undefined,
    featureEnabled: boolean | undefined,
    featureFlag: FeatureFlag,
  ) => {
    const headers = existingHeaders ?? {};
    if (featureEnabled) {
      headers['x-enable-feature'] = [headers['x-enable-feature'], featureFlag].filter((x) => x).join(',');
    } else {
      headers['x-disable-feature'] = [headers['x-disable-feature'], featureFlag].filter((x) => x).join(',');
    }
    return headers;
  };

  public static modifyCustomerName = (customerName: string) => {
    let splitString: string[] = [];
    if (customerName.includes(',')) {
      splitString = customerName.split(',');
      if (!splitString[1].trim()) {
        return splitString[0].trim();
      }
      return splitString[1].trim().split(' ')[0];
    }
    return customerName.split(' ')[0];
  };

  // Returns ColumnId based on ratePlan and effectiveDate
  public static getPlanColumnIds = (PlanColumns: PlansColumns, ratePlan: string, effectiveDate?: string | undefined) => {
    const plans = PlanColumns[ratePlan];

    // return empty array for unsupported rate plan
    if (!plans) {
      return [];
    }
    const currentPlan = plans && plans.find(
      ({ effectiveFrom, effectiveTill }) => (
        effectiveDate === effectiveTill || effectiveDate === effectiveFrom),
    );
    return currentPlan?.columns || plans[0].columns;
  };
}
